import React from 'react';
import { ExerciseOrSuperset, RoutineExercise } from '../../../types/Fisiofit/routine';
import { isSuperset } from '../../../utils/supersetUtils';
import { ExerciseRowProps } from '../types';
import { getDuplicateExerciseIndexes } from '../utils/exercises';
import { SupersetItem } from './SupersetItem';
import { SingleExerciseItem } from './SingleExerciseItem';

type ExerciseItemProps = ExerciseRowProps & {
  exercise: ExerciseOrSuperset;
  dayIndex: number;
  exerciseIndex: number;
  provided?: any;
  snapshot?: any;
};

// Renderizar un ejercicio con su formulario de edición
export const ExerciseItem = ({ exercise, dayIndex, exerciseIndex, provided, snapshot, ...rowProps }: ExerciseItemProps) => {
  const { form, isEditing, isCreating, expandedExerciseIds } = rowProps;
  const exerciseId = `${dayIndex}-${exerciseIndex}`;
  const isExpanded = expandedExerciseIds[exerciseId] || false;
  const isDragging = snapshot?.isDragging;

  // Detección de duplicados para ejercicios individuales
  const duplicateIndexes = getDuplicateExerciseIndexes(form.exerciseDays[dayIndex].exercises);
  const isDuplicate = duplicateIndexes.includes(exerciseIndex);
  const shouldDisableInputs = (isEditing || isCreating) && isDuplicate;

  // Si es una superserie
  if (isSuperset(exercise)) {
    return (
      <SupersetItem
        {...rowProps}
        exercise={exercise}
        dayIndex={dayIndex}
        exerciseIndex={exerciseIndex}
        provided={provided}
        exerciseId={exerciseId}
        isExpanded={isExpanded}
        isDragging={isDragging}
      />
    );
  }

  // Si es un ejercicio individual
  return (
    <SingleExerciseItem
      {...rowProps}
      exercise={exercise as RoutineExercise}
      dayIndex={dayIndex}
      exerciseIndex={exerciseIndex}
      provided={provided}
      isExpanded={isExpanded}
      isDragging={isDragging}
      isDuplicate={isDuplicate}
      shouldDisableInputs={shouldDisableInputs}
    />
  );
};
